<h2 class="rs-table-title">
  <span
    class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-no-margin rs-bg-skeleton rs-anim-loading"
  ></span>
</h2>
<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-column">
    <div
      class="panel rs-wd-s10 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <div class="rs-flex-row rs-flex-middle rs-flex-collapse">
      <div class="rs-flex-columns rs-flex-grow">
        <div
          class="panel rs-h-m2 rs-no-padding rs-margin-bottom2 rs-margin-right1 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
      <div class="rs-flex-columns">
        <div
          class="panel rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<hr class="rs-margin-bottom1" />
<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-column">
    <div
      class="panel rs-wd-s10 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <div class="rs-flex-row rs-flex-middle rs-flex-collapse">
      <div class="rs-flex-columns rs-flex-grow">
        <div
          class="panel rs-h-m2 rs-no-padding rs-margin-bottom2 rs-margin-right1 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
      <div class="rs-flex-columns">
        <div
          class="panel rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<hr class="rs-margin-bottom1" />
<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-column">
    <div
      class="panel rs-wd-s10 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
    ></div>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <div class="rs-flex-row rs-flex-middle rs-flex-collapse">
      <div class="rs-flex-columns rs-flex-grow">
        <div
          class="panel rs-h-m2 rs-no-padding rs-margin-bottom2 rs-margin-right1 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
      <div class="rs-flex-columns">
        <div
          class="panel rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<hr class="rs-margin-bottom1" />
